import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-service-offered',
  templateUrl: './service-offered.component.html',
  styleUrls: ['./service-offered.component.css']
})
export class ServiceOfferedComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  columnNames = [{
    id: 'sno',
    value: 'S.No.',

  }, {
    id: 'service_category',
    value: 'Service Category',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  showUploadModal: boolean = false;
  selectedFile: File | null = null;
  uploadAccess: boolean;
  uploadErrors: any = [];
  referenceOptions1: any[];
  referenceOptions2: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('5');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    // this.displayedColumns = this.columnNames.map(x => x.id);


    this.getserviceoffered('');
    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor() {
    this.router.navigate(['add-Serviceoffered']);
  }



  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceoffered(service_offered_id, '1', '', '', '', this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult = [];
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getserviceoffered API');
          this.showLoader = false;
        });
  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_category_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(service_category_id);
    if (confirm('Deleting of this Service Offered is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridDataNew(service_category_id, 'service_category_id', 'service_offered', 'status', '1').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      this.uploadAccess = !!mod.upload;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      this.uploadAccess = false;
      return false;
    }
  }

  openUploadModal() {
    this.showUploadModal = true;
  }

  closeUploadModal() {
    this.showUploadModal = false;
    this.uploadErrors = [];
    this.selectedFile = null;
  }

  // async downloadSample() {
  //   const XLSX = await import('xlsx');
  //   const wb = XLSX.utils.book_new();

  //   // Sheet 1: Customer Data Template
  //   const customerData = [
  //     ['Customer Name', 'Phone', 'How do You Know about this Place?'],
  //     ['', '', ''] // Empty row for data entry
  //   ];
  //   const ws1 = XLSX.utils.aoa_to_sheet(customerData);
  //   XLSX.utils.book_append_sheet(wb, ws1, 'customer_data');

  //   // Sheet 2: Reference Options
  //   const referenceOptions = [
  //     ['Reference Options For How do You Know about this Place?'],
  //     ['Banner'],
  //     ['Direct Walk In'],
  //     ['EGB Staff'],
  //     ['Facebook'],
  //     ['Google'],
  //     ['Instagram'],
  //     ['Missed To Ask'],
  //     ['Other'],
  //     ['Our Customer'],
  //     ['Our Staff'],
  //     ['Pamphlet'],
  //     ['Referred By Another Person']
  //   ];
  //   const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
  //   XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');

  //   XLSX.writeFile(wb, 'customer_template.xlsx');
  // }

  downloadSample() {

    this.loginservice.getservicecategory('', '1', this.currentUser).subscribe(
      data => {
        this.loginservice.getserviceList('', this.currentUser).subscribe(
          data1 => {
            this.referenceOptions1 = data['comp_details'].map(item => [item.service_category]);
            this.referenceOptions2 = data1['comp_details'].map(item => [item.service_descForUpload]);
            const wb = XLSX.utils.book_new();
            const customerData = [
              ['Service Category', 'Service Name'],
              ['', '']
            ];
            const ws1 = XLSX.utils.aoa_to_sheet(customerData);
            XLSX.utils.book_append_sheet(wb, ws1, 'service_mapping_data');

            const ws2 = XLSX.utils.aoa_to_sheet(this.referenceOptions1);
            const ws3 = XLSX.utils.aoa_to_sheet(this.referenceOptions2);
            XLSX.utils.book_append_sheet(wb, ws2, 'service_category');
            XLSX.utils.book_append_sheet(wb, ws3, 'service_name');

            XLSX.writeFile(wb, 'service_mapping_template.xlsx');
          });
      });


    // const wb = XLSX.utils.book_new();

    // const customerData = [
    //   ['Service Category', 'Service Name'],
    //   ['', '']
    // ];
    // const ws1 = XLSX.utils.aoa_to_sheet(customerData);
    // XLSX.utils.book_append_sheet(wb, ws1, 'service_mapping_data');

    // const referenceOptions = [
    //   ['Gender'],
    //   ['Both'],
    //   ['Female'],
    //   ['Male'],

    // ];
    // const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
    // XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');

    // XLSX.writeFile(wb, 'service_mapping_template.xlsx');
  }


  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  uploadExcel() {
    if (!this.selectedFile) return;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.loginservice.uploadServiceMapping(formData, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show(`Successfully uploaded ${data['count']} Service Mapping`, { cssClass: 'alert-success' });
          this.closeUploadModal();
          this.ngOnInit();
        } else if (data['status'] === 'error') {
          this.uploadErrors = data['message'];
          // alert(data['message'] || 'Upload failed');
          // this._flashMessagesService.show(data['message'] || 'Upload failed', { cssClass: 'alert-danger' });
        } else {
          this._flashMessagesService.show('Upload failed', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error uploading file', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }
  // aaaaa
  exportToExcel() {
    const wb = XLSX.utils.book_new();
    const exportData = [];

    this.dataresult.forEach((category, catIndex) => {
      // Add category header row with bold indicator
      exportData.push(['S.No.', 'Category']);
      exportData.push([catIndex + 1, category.service_category]);

      // Add service headers with S.No.
      const serviceHeaders = ['S.No.', 'Service Description', 'Price (S)', 'Price (M)', 'Price (L)'];
      if (this.currentUser.dynamic_membership == '1') {
        serviceHeaders.push('Membership Price (S)', 'Membership Price (M)', 'Membership Price (L)');
      }
      exportData.push(serviceHeaders);

      // Add services under this category with numbering
      if (category.offered && category.offered.length > 0) {
        category.offered.forEach((service, serviceIndex) => {
          const serviceRow = [
            `${catIndex + 1}${String.fromCharCode(97 + serviceIndex)}`,
            service.service_desc,
            service.price_s,
            service.price_m,
            service.price_l
          ];

          if (this.currentUser.dynamic_membership == '1') {
            serviceRow.push(
              service.membership_price_s,
              service.membership_price_m,
              service.membership_price_l
            );
          }

          exportData.push(serviceRow);
        });
      }

      // Add empty rows between categories
      exportData.push([]);
      exportData.push([]);
    });

    const ws = XLSX.utils.aoa_to_sheet(exportData);

    // Set column widths
    ws['!cols'] = [
      { wch: 10 },
      { wch: 40 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'Service Offered');
    XLSX.writeFile(wb, `service_offered_${new Date().getTime()}.xlsx`, { bookType: 'xlsx' });
  }

}







// WEBPACK FOOTER //
// ./src/app/service-offered/service-offered.component.ts